/**
 * Brands rendered in CTF
 * NOTE: This enum is frozen at runtime to prevent accidental mutation.
 */
export var Brands;
(function (Brands) {
    Brands["BUNTE"] = "bunte";
    Brands["CHIP"] = "chip";
    Brands["FOCUS"] = "focus";
    Brands["FITFORFUN"] = "fitforfun";
    Brands["FINANZEN100"] = "finanzen100";
    Brands["MITTIER"] = "mittier";
    Brands["MITSTERNEN"] = "mitsternen";
    Brands["MITBEZIEHUNG"] = "mitbeziehung";
    Brands["TVTODAY"] = "tvtoday";
})(Brands || (Brands = {}));
Object.freeze(Brands);
/**
 * Brands imported from legacy systems using S3 legacy import
 * Value used in `legacy.brand` field
 * https://docs.bf-ctf-development.aws.bfops.io/docs/Advanced%20Topics/Legacy%20Import/setup/
 */
export var LegacyBrands;
(function (LegacyBrands) {
    LegacyBrands["BUNTE"] = "bunte";
    LegacyBrands["CHIP"] = "chip";
    LegacyBrands["FOCUS"] = "focus";
    LegacyBrands["PRAXISTIPPS"] = "praxistipps";
})(LegacyBrands || (LegacyBrands = {}));
Object.freeze(LegacyBrands);
export const VerticalsBrands = Object.freeze([Brands.MITTIER, Brands.MITSTERNEN, Brands.MITBEZIEHUNG, Brands.TVTODAY]);
/**
 * BrandList derived from Brands enum values.
 * Kept frozen to ensure runtime immutability.
 */
export const BrandList = Object.freeze(Object.values(Brands));
/**
 * Brands imported from legacy systems using S3 legacy import
 * Value used in `legacy.brand` field
 * https://docs.bf-ctf-development.aws.bfops.io/docs/Advanced%20Topics/Legacy%20Import/setup/
 */
export const LegacyBrandList = Object.freeze(Object.values(LegacyBrands));
export const legacyCMSSources = ['bunte-stack', 'escenic', 'interred', 'fff-cms'];
export const brandToLegacyCMSMapping = {
    [Brands.BUNTE]: 'bunte-stack',
    [Brands.CHIP]: 'interred',
    [Brands.FOCUS]: 'escenic',
    [Brands.FITFORFUN]: 'fff-cms',
};
export const legacyCMSToBrandMapping = {
    'bunte-stack': Brands.BUNTE,
    interred: Brands.CHIP,
    escenic: Brands.FOCUS,
    'fff-cms': Brands.FITFORFUN,
};
//# sourceMappingURL=brandEnums.js.map